<template>
  <div class="search-content">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'ExameCenterLayout',
    data () {
      return {
        tabs: {
          items: [  
            // {
            //   key: '3',
            //   title: '省市奖励'
            // },
            {
              key: '4',
              title: '地市推广奖励'
            },
            {
              key: '5',
              title: '加盟合伙人/内部员工奖励'
            },
            {
              key: '6',
              title: '地市推广人员设置'
            }
          ],
          active: () => {
            switch (this.$route.path) { 
              case '/qcxj/shengshiRewardsList':
                return '3'
              case '/qcxj/cityRewardsList':
                return '4'
              case '/qcxj/partnerRewardsList':
                return '5'
              case '/qcxj/citySetting':
                return '6'
              default:
                return '3'
            }
          },
          callback: (key) => {
            switch (key) { 
              case '3':
                this.$router.push('/qcxj/shengshiRewardsList')
                break
              case '4':
                this.$router.push('/qcxj/cityRewardsList')
                break
              case '5':
                this.$router.push('/qcxj/partnerRewardsList')
                break
              case '6':
                this.$router.push('/qcxj/citySetting')
                break
              default:
                this.$router.push('/workplace')
            }
          }
        },
        search: false
      }
    },
    computed: {

    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .search-head{
    background-color: #fff;
    margin: -25px -24px -24px;
    .search-input{
      text-align: center;
      margin-bottom: 16px;
    }
  }
  .search-content{
    margin-top: 0px;
  }
</style>
